const InputBox = ({ title, placeholder }) => {
  return (
    <div className="mt-8">
      <p className="mb-4 font-pop text-[22px] font-semibold text-darkGreen">
        {title}
      </p>

      <input
        type="text"
        className="w-full rounded border border-lightGray px-6 py-[22px] font-pop  text-lg text-black text-opacity-50  focus:outline-none"
        placeholder={placeholder || "Enter here"}
      />
    </div>
  );
};

export default InputBox;
